import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import _ from 'lodash';
// import PullToRefresh from 'react-pullable';
import { HEADER } from '_constants';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { appointmentActions, headerActions } from 'actions';
import ContentLoader from 'components/common/loaders/ContentLoader';

import DateView from './DateView';
import MonthView from './MonthView';
import { bottomnavActions } from '../../actions/bottomnav.actions';

const headerSettings =
{
  type: HEADER.UPDATE_HEADER,
  showHeader: true,
  headerTitle: 'Appointments',
  hasBackButton: false,
  hasNotificationIcon: true
};

class Appointments extends React.Component {
  static propTypes = {
    fetch: PropTypes.func.isRequired,
    appointments: PropTypes.array,
    monthAppointments: PropTypes.array.isRequired,
    setHeader: PropTypes.func.isRequired,
    currentDate: PropTypes.object,
    activeDate: PropTypes.object,
    changeActiveDate: PropTypes.func,
    isDateView: PropTypes.bool.isRequired,
    toggleView: PropTypes.func.isRequired,
    changeActiveItem: PropTypes.func.isRequired
  }

  toggleAppointmentView = () => {
    const { toggleView = () => { } } = this.props;
    toggleView();
  }

  pullToRefreshHandler = () => {
    this.initialAppointment();
  }

  componentDidMount = async () => {
    this.initialAppointment();
  }

  initialAppointment = async () => {
    this.props.setHeader(headerSettings);
    this.props.changeActiveItem('Appointments');
    await this.props.fetch();
  }

  fetchMonthAppointments = async (monthMoment) => {
    const start = monthMoment ? monthMoment.startOf('month') : moment().startOf('month');
    const end = moment(start).endOf('month');
    const response = await this.props.fetch(start.format('MM/DD/YYYY'), end.format('MM/DD/YYYY'), true);
    return response;
  }

  changeMonthActiveDate = (activeDate, actionType) => {
    this.props.changeActiveDate(activeDate, actionType);
  }

  render () {
    const { appointments, monthAppointments, currentDate, isDateView, activeDate } = this.props;
    return (
      <React.Fragment>
        <section className='page-content appointments-page'>
          {/* <PullToRefresh
            onRefresh={this.pullToRefreshHandler}
            spinnerOffset={10}
            distThreshold={100}
            spinnerColor='0000FF'
          > */}
          <div className='toggle-container'>
            <ul>
              <li>
                <a className={isDateView ? 'active' : ''} onClick={() => this.toggleAppointmentView()}>To Do</a>
              </li>
              <li>
                <a className={!isDateView ? 'active' : ''} onClick={() => this.toggleAppointmentView()}>Month View</a>
              </li>
            </ul>
          </div>
          <div className='page-content-body appointments-page-body'>
            {
              !appointments ? <ContentLoader isLoading />
                : isDateView
                  ? <DateView appointments={appointments} />
                  : <MonthView
                    appointmentList={monthAppointments}
                    currentDate={currentDate}
                    fetchMonthAppointments={this.fetchMonthAppointments}
                    changeMonthActiveDate={this.changeMonthActiveDate}
                    activeDate={activeDate} />
            }
          </div>
          {/* </PullToRefresh> */}
        </section>

      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const { appointments } = state;
  const currentDate = appointments.activeDate ? _.get(appointments, 'activeDate', null) : moment();
  return {
    appointments: _.get(appointments, 'appointments', null),
    monthAppointments: _.get(appointments, 'monthAppointments', []),
    isDateView: appointments.isDateView,
    activeDate: _.get(appointments, 'activeDate', moment()),
    currentDate
  };
};

const mapDispatchToProps = dispatch => ({
  fetch: bindActionCreators(appointmentActions.fetch, dispatch),
  setHeader: bindActionCreators(headerActions.setHeader, dispatch),
  changeActiveDate: bindActionCreators(appointmentActions.changeActiveDate, dispatch),
  toggleView: bindActionCreators(appointmentActions.toggleView, dispatch),
  changeActiveItem: bindActionCreators(bottomnavActions.changeActiveItem, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Appointments));
